import React from 'react';
import PropTypes from 'prop-types';

const ActionButton = ({ children, onClick, className = '', title, disabled, ...props }) => {
  return (
    <button
      type="button"
      {...props}
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={`
        flex items-center justify-center gap-2 
        rounded-md px-2 py-1.5 
        text-gray-900 font-medium 
        !bg-transparent 
        !border-none
        !shadow-none
        !outline-none
        focus:!outline-none
        focus-visible:!outline-none
        focus:!ring-0
        hover:!bg-gray-200 
        active:!bg-gray-300 
        transition-colors duration-200 
        disabled:opacity-50 disabled:pointer-events-none
        ${className}
      `}
    >
      {children}
    </button>
  );
};

ActionButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ActionButton;
